import {Katalog} from './katalog.model';
import {Faehigkeit} from './faehigkeit.model';
import {Requests} from './request.model';
import {LanguageOption} from '../constants/languages';
import {ProfilerLanguage} from '../constants/profiler-language';
import {Moment} from 'moment';
import {Advisor} from './advisor.model';

export type TravelWillingness = 'Ja' | 'Eingeschränkt' | 'Nein' | '';

export interface FilterOptions {
  consultantName: string;
  travelWillingness: TravelWillingness;
  availableFrom: Moment | null;
  advisor: Advisor;
  isApplicant: boolean;
  isFreelancer: boolean;

  languages: LanguageOption[];
  isLanguagesAndMode: boolean;

  // Oberflaechensprache des Profilers, unabhaengig von `languages`; `null` heisst „Alle".
  profilerLanguage: ProfilerLanguage | null;

  branches: Requests[];
  isBranchesAndMode: boolean;

  catalog: Katalog[];
  isCatalogAndMode: boolean;

  education: string[];
  isEducationAndMode: boolean;

  educationInstitution: string[];
  isEducationInstitutionAndMode: boolean;

  projectCompany: string[];
  isProjectCompanyAndMode: boolean;

  focuses: Requests[];
  isFocusesAndMode: boolean;

  projectRole: string[];
  isProjectRolesAndMode: boolean;

  skills: Faehigkeit[];
  isSkillsAndMode: boolean;

  certificates: string[];
  isCertificatesAndMode: boolean;

  trainings: Requests[];
  isTrainingsAndMode: boolean;

  securityCheckCompletedOn: Moment | null;
}

export function createFilterOptions(): FilterOptions {
  return {
    consultantName: '',
    travelWillingness: '',
    availableFrom: null,
    advisor: null,
    isApplicant: false,
    isFreelancer: false,

    languages: [],
    isBranchesAndMode: false,

    profilerLanguage: null,

    branches: [],
    isLanguagesAndMode: false,

    catalog: [],
    isCatalogAndMode: false,


    education: [],
    isEducationAndMode: false,

    educationInstitution: [],
    isEducationInstitutionAndMode: false,

    projectCompany: [],
    isProjectCompanyAndMode: false,

    focuses: [],
    isFocusesAndMode: false,

    projectRole: [],
    isProjectRolesAndMode: false,

    skills: [],
    isSkillsAndMode: false,

    trainings: [],
    isTrainingsAndMode: false,

    certificates: [],
    isCertificatesAndMode: false,

    securityCheckCompletedOn: null,
  };
}
